// Copyright (c) 2026 Signal from Noise, Inc. All rights reserved.
//
// This software is the confidential and proprietary information of
// Signal from Noise, Inc. You shall not disclose such Confidential Information
// and shall use it only in accordance with the terms of a separate license
// agreement entered into with Signal from Noise, Inc.
//
// Authors: /AUTHORS

import { contentTypeForExtension, getContentTypes } from "./mime.gen";

const contentTypes = new Set(getContentTypes());

/**
 * The filename extension, dot included and lowercased (e.g. `.png`), matching
 * Go's `filepath.Ext` closely enough: a dotless name, or one whose only dot
 * leads it (a dotfile), has no extension rather than reading the whole name
 * as one.
 */
export function fileExtension(name: string): string {
  const dot = name.lastIndexOf(".");
  return dot > 0 ? name.slice(dot).toLowerCase() : "";
}

/**
 * The content type the project library takes this file as, or undefined when
 * it takes the file not at all: its declared MIME type when the library
 * accepts that, otherwise the type its filename extension names. Some sources (WKWebView
 * drag/drop, certain Finder file kinds, a browser that doesn't know the
 * extension) never set a reliable File.type, so the extension decides on its
 * own rather than only as an empty-type fallback.
 */
export function libraryContentType(file: { type: string; name: string }): string | undefined {
  if (contentTypes.has(file.type)) return file.type;
  return contentTypeForExtension.get(fileExtension(file.name));
}

/** Reports whether the project library accepts this file; see libraryContentType. */
export function isSupportedLibraryFile(file: { type: string; name: string }): boolean {
  return libraryContentType(file) !== undefined;
}
